import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import PublicationDateTime from './dates/publication_date_time';
import PublicationDate from './dates/publication_date';
import { getRelativePath } from '../../utils/url';
import { timestampToArchivesURLPath } from '../../utils/date';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';

export default class ArchivesLink extends Component {
  shouldComponentUpdate = (nextProps) =>
    nextProps.timestamp !== this.props.timestamp;

  handleClick = () => {
    sendAnalyticsEvent(
      'Date',
      'Click',
      this.props.eventLabel
    );
    const timestampPath = timestampToArchivesURLPath(this.props.timestamp);
    sendDataLayerEvent('Click', {
      pageModule: 'Header',
      linkType: 'date',
      linkURL: getRelativePath(timestampPath, this.context.edition_data),
      linkTitle: this.props.eventLabel,
      itemName: this.props.eventLabel,
      linkHeadline: this.props.eventLabel
    });
  };

  formattedArchivesDate = () => React.createElement(
    this.props.format === 'datetime'
      ? PublicationDateTime
      : PublicationDate,
    this.props
  );

  render() {
    const timestampPath = timestampToArchivesURLPath(this.props.timestamp);
    return (
      <Link
        to={getRelativePath(timestampPath, this.context.edition_data)}
        onClick={this.handleClick}
        rel="nofollow"
      >
        {this.formattedArchivesDate()}
      </Link>
    );
  }
}

ArchivesLink.propTypes = {
  timestamp: PropTypes.number.isRequired,
  eventLabel: PropTypes.string.isRequired,
  format: PropTypes.oneOf([
    'date',
    'datetime'
  ]).isRequired
};

ArchivesLink.contextTypes = {
  edition_data: PropTypes.object
};
